module.exports = __webpack_public_path__ + "static/media/iPhone8.caf0a172.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/granvillebands/iPhone8.png
// module id = 167
// module chunks = 0